//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { ImageWithErrorHandling } from '@components/atoms/image-with-error-handling/ImageWithErrorHandling';

interface VariantImagePreviewProps {
  alt: string;
  src: string | undefined;
}

export const VariantImagePreview = ({ alt, src }: VariantImagePreviewProps) => {
  return (
    <PreviewContainer>
      <PreviewImage alt={alt} src={src} />
    </PreviewContainer>
  );
};

const PreviewContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 75px;
    height: 75px;
    background-color: ${theme.colors.gray1};
    border-radius: ${theme.borderRadii[1]};
    overflow: hidden;
  `}
`;

const PreviewImage = styled(ImageWithErrorHandling)`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border: 1px solid ${theme.colors.gray2};
    border-radius: ${theme.borderRadii[2]};
    object-fit: contain;
  `}
`;
